import React, { useEffect } from "react";
import TrainingClassTable from "./components/TrainingClassTable";
import { connect } from "react-redux";
import SummaryCard from "components/widget/SummaryCard";
import { Award, BookOpen, TrendingUp, Users } from "lucide-react";
import {
    getTeamCourseStat
} from "../../../redux/overview/overviewState";


const TrainingClasses = ({
	getStats,
	recordStat
}) => {

	useEffect(() => {
		getStats();
	}, [getStats]);
	
	return (
	    <div className="space-y-6">
			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
				<SummaryCard
					title={"Total Courses"}
					icon={<BookOpen size={16}/>}
					displayCount={recordStat?.available_courses}
					description={"Available programs"}
					textColor="text-slate-900"
				/>	

				<SummaryCard
					title={"Total Enrollments"}
					icon={<Users size={16}/>}
					displayCount={recordStat?.enrolled_count}
					description={"Across all courses"}
					textColor="text-blue-600"
				/>

				<SummaryCard
					title={"Completed"}
					icon={<Award size={16}/>}
					displayCount={recordStat?.completed_count}
					description={"Active learners"}
					textColor="text-green-600"
				/>		
				<SummaryCard
					title={"Avg. Completion"}
					icon={<TrendingUp size={16}/>}
					displayCount={`${recordStat?.average_completion}%`}
					description={"Success rate"}
					textColor="text-purple-600"
				/>	
			</div>
	      	<TrainingClassTable/>
	    </div>
    );
};

const mapStateToProps = (state) => ({
	recordStat: state.overview.teamCourseStat?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getStats: (data) => dispatch(getTeamCourseStat(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingClasses);